module.exports = __webpack_public_path__ + "assets/202509252035/img/moom.5f8ce81b.jpg";